/**
 * READ ME :)
 *
 * You can either add html elements, or the selector
 * ex. new Lightbox(document.querySelectorAll('.mtt-gallery__image img')) || new Lightbox('.mtt-gallery__image img')
 *
 * You have to pass the img tags.
 * You can add a [data-lightbox] attribute to the <img> with the full size url.
 * If the attribute above is not added, the [src] will be used.
 *
 * You don't have to add any html markup, as the class below will create all the elements for you.
 *
 * Just remember the scss file + arrow img ;)
 * img: /assets/img/icons/lightbox-arrow.svg
 * scss: /resources/scss/public/modules/_lightbox.scss
 */

export default class Lightbox {
  constructor (elements) {
    this.items = typeof elements === 'string' ? document.querySelectorAll(elements) : elements
    if (this.items.length > 0) {
      this.init()
    }
  }

  init () {
    // setup lightbox markup
    this.createLightbox()
    // add events
    this.addOpenCloseEvents()
    // add arrow events
    this.addArrowEvents()

    // make sure the lightbox is only visible when css has been loaded
    setTimeout(() => {
      this.lightboxEl.classList.remove('not-initialized')
    }, 500)
  }

  createLightbox () {
    // create main div
    this.lightboxEl = document.createElement('div')
    this.lightboxEl.classList.add('mtt-lightbox')
    this.lightboxEl.classList.add('not-initialized')

    // create inner div
    this.lightboxImageWrap = document.createElement('div')
    this.lightboxImageWrap.classList.add('mtt-lightbox__image-wrap')
    this.lightboxEl.appendChild(this.lightboxImageWrap)

    // create close div
    this.lightboxClose = document.createElement('div')
    this.lightboxClose.classList.add('mtt-lightbox__close')
    this.lightboxEl.appendChild(this.lightboxClose)

    // create overlay div
    this.lightboxOverlay = document.createElement('div')
    this.lightboxOverlay.classList.add('mtt-lightbox__overlay')
    this.lightboxEl.appendChild(this.lightboxOverlay)

    // create image
    this.lightboxImage = document.createElement('img')
    this.lightboxImage.classList.add('mtt-lightbox__image')
    this.lightboxImage.setAttribute('alt', 'mtt-lightbox__image')
    this.lightboxImageWrap.appendChild(this.lightboxImage)

    // create arrows
    this.lightboxArrowLeft = document.createElement('div')
    this.lightboxArrowLeft.classList.add('mtt-lightbox__arrow')
    this.lightboxArrowLeft.classList.add('left')
    this.lightboxEl.appendChild(this.lightboxArrowLeft)
    this.lightboxArrowRight = document.createElement('div')
    this.lightboxArrowRight.classList.add('mtt-lightbox__arrow')
    this.lightboxArrowRight.classList.add('right')
    this.lightboxEl.appendChild(this.lightboxArrowRight)

    // append main div
    document.body.appendChild(this.lightboxEl)
  }

  getImages () {
    const imagesArray = []
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i]
      imagesArray.push(this.getAttr(item))
    }
    return imagesArray
  }

  openLightbox () {
    this.lightboxEl.classList.add('open')
    this.updateInitalSrc()
  }

  closeLightbox () {
    this.lightboxEl.classList.remove('open')
  }

  updateInitalSrc () {
    const src = this.getAttr(this.currentItem)
    this.updateSrc(src)
  }

  updateSrc (src) {
    this.currentID = this.getImages().indexOf(src)
    this.lightboxImage.src = src
  }

  getAttr (item) {
    const fullSrc = item.getAttribute('data-lightbox')
    const src = item.getAttribute('src')
    return fullSrc || src
  }

  addOpenCloseEvents () {
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i]
      item.addEventListener('click', (e) => {
        e.preventDefault()
        this.currentItem = item
        this.openLightbox()
      })
    }

    const closeButtons = [this.lightboxClose, this.lightboxOverlay]
    for (let i = 0; i < closeButtons.length; i++) {
      const closeButton = closeButtons[i]
      closeButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.closeLightbox()
      })
    }

    document.addEventListener('keydown', (e) => {
      const key = e.key || e.keyCode
      if (key === 'Escape' || key === 'Esc' || key === 27) {
        this.closeLightbox()
      }
    })
  }

  addArrowEvents () {
    if (this.lightboxArrowLeft) {
      this.lightboxArrowLeft.addEventListener('click', (e) => {
        e.preventDefault()
        this.goLeft()
      })
    }

    if (this.lightboxArrowRight) {
      this.lightboxArrowRight.addEventListener('click', (e) => {
        e.preventDefault()
        this.goRight()
      })
    }

    document.addEventListener('keydown', (e) => {
      const key = e.key || e.keyCode
      if (key === 'ArrowLeft' || key === 37) {
        this.goLeft()
      } else if (key === 'ArrowRight' || key === 39) {
        this.goRight()
      }
    })
  }

  goLeft () {
    const images = this.getImages()
    const src = this.currentID < 1 ? images[this.items.length - 1] : images[this.currentID - 1]
    this.updateSrc(src)
  }

  goRight () {
    const images = this.getImages()
    const src = this.currentID === this.items.length - 1 ? images[0] : images[this.currentID + 1]
    this.updateSrc(src)
  }
}
